import Fornecedor from './componentes/Fornecedor.vue';
import Alterar from './componentes/Alterar.vue';

export default {
  path: 'web-fornecedor',
  component: Fornecedor,
  meta: { auth: true },
  children: [
    {
      path: 'alterar',
      name: 'web-fornecedor.alterar',
      component: Alterar,
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/web-fornecedor/rotas.js